/**
 * Employee Portal access — keep FE nav, routes, and deep-link remaps aligned.
 * Company hierarchy admins manage people via HR modules; they do not use the employee portal.
 */

/** Roles that may open the personal Employee Portal. */
export const SELF_SERVICE_ROLES = [
    'Salesman',
    'WarehouseStaff',
    'StoreStaff',
    'AccountsStaff',
    'Accountant',
    'HRManager',
    'ASM',
    'ZSM',
    'RSM',
    'NSM',
];

/** Org admins — management only; no Employee Portal. */
export const SELF_SERVICE_EXCLUDED_ROLES = [
    'Owner',
    'CompanyAdmin',
    'SoleDistributorAdmin',
    'SubDistributorAdmin',
    'SaaSAdmin',
];

export const SELF_SERVICE_PATH = '/self-service';
export const LEAVE_MANAGEMENT_PATH = '/hr/leave';
export const HR_MANAGEMENT_HOME = '/hr/leave';

export function canAccessSelfService(role) {
    if (!role) return false;
    if (SELF_SERVICE_EXCLUDED_ROLES.includes(role)) return false;
    return SELF_SERVICE_ROLES.includes(role);
}

/**
 * Resolve notification / quick-action links so each role lands on the right surface.
 */
export function resolveSelfServiceDeepLink(link, role) {
    if (!link || typeof link !== 'string') return link;
    const path = link.split('?')[0];

    // Legacy plural leave path → management
    if (path === '/hr/leaves') {
        return LEAVE_MANAGEMENT_PATH;
    }

    const isSelfServiceTarget =
        path === '/self-service'
        || path === '/hr/self-service';

    if (isSelfServiceTarget) {
        if (SELF_SERVICE_EXCLUDED_ROLES.includes(role)) {
            return LEAVE_MANAGEMENT_PATH;
        }
        return SELF_SERVICE_PATH;
    }

    return link;
}
